type MicroDataAttribute = "itemProp" | "itemScope" | "itemType";

export const microDataAttributeGenerator = (camelCase: boolean) => {
  return (attr: MicroDataAttribute, value: any) => {
    const attribute = camelCase ? attr : attr.toLowerCase();
    return {
      [attribute]: value
    };
  };
};
